import { createReducer, on } from '@ngrx/store';
import {
  IAccessAlertAdmin,
  IAccessContext,
  IComponentAccess,
  ICurrentContext,
  ILinkedAccountInfo,
  UserRole,
} from '../../models/access';
import {
  determineHighestUserRole,
  mapToComponentAccessContext,
  mapToUserAccessContext,
} from '../../utils/access-mapping.utils';
import { resetAppState } from '../global/global.actions';
import { AccessActions } from './access.actions';

export const accessFeatureKey = 'access';

export interface AccessState {
  userAccessContext: IAccessContext[] | null;
  componentAccessContext: IComponentAccess[] | null;
  guardianLinks: ILinkedAccountInfo[];
  selectedAccountCodes?: string[];
  currentContext: ICurrentContext | null;
  highestUserRole: UserRole | null;
  guardianAccountLinks: ILinkedAccountInfo[];
  accessAlertAdmin: IAccessAlertAdmin | null;
  loading: boolean;
  error: any;
}

export const initialState: AccessState = {
  userAccessContext: null,
  componentAccessContext: null,
  guardianLinks: [],
  currentContext: null,
  highestUserRole: null,
  guardianAccountLinks: [],
  accessAlertAdmin: null,
  loading: false,
  error: null,
};

export const accessReducer = createReducer(
  initialState,
  on(AccessActions.loadUserAccess, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(AccessActions.loadUserAccessSuccess, (state, { accessData }) => {
    const userAccessContext = mapToUserAccessContext(accessData);
    const componentAccessContext = mapToComponentAccessContext(accessData);

    return {
      ...state,
      userAccessContext,
      componentAccessContext,
      highestUserRole: determineHighestUserRole(accessData.studentDtoList),
      loading: false,
      error: null,
    };
  }),
  on(AccessActions.loadUserAccessFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(AccessActions.loadGuardianIds, (state, { guardianLinks }) => ({
    ...state,
    guardianAccountLinks: guardianLinks,
  })),
  on(AccessActions.loadGuardianLinks, (state, { guardianLinks }) => ({
    ...state,
    guardianLinks,
  })),
  on(AccessActions.setCurrentContext, (state, { componentName, studentId, guardianId }) => ({
    ...state,
    currentContext: {
      componentName,
      studentId,
      guardianId,
    },
  })),
  on(AccessActions.clearCurrentContext, (state) => ({
    ...state,
    currentContext: null,
  })),
  on(AccessActions.clearAccessData, () => initialState),
  on(AccessActions.clearUserAccess, (state) => ({
    ...state,
    userAccessContext: null,
    componentAccessContext: null,
    guardianLinks: [],
    highestUserRole: null,
    currentContext: null,
  })),
  on(AccessActions.setSelectedAccountCodes, (state, { selectedAccountCodes }) => ({
    ...state,
    selectedAccountCodes,
  })),
  on(AccessActions.setAccessAlertAdmin, (state, { accessAlertAdmin }) => ({
    ...state,
    accessAlertAdmin: accessAlertAdmin,
  })),
  on(AccessActions.clearAccessAlertAdmin, (state) => ({
    ...state,
    accessAlertAdmin: null,
  })),
  on(resetAppState, () => initialState),
);
